import React from 'react';
import { Palette, Check } from '@phosphor-icons/react';
import { useTheme, THEMES } from '../hooks/useTheme';

/**
 * Small reusable theme picker — sits inside chat three-dot menu.
 * Renders a header row + 5 color-swatch chips (Light/Dark/Green/Blue/Dark Blue).
 * Persists selection to localStorage via useTheme().
 */
const ThemeToggleMenuItem = ({ onClick }) => {
  const { theme, setTheme } = useTheme();
  return (
    <div className="border-t px-3 py-2" data-testid="theme-picker-menu-item">
      <div className="flex items-center gap-2 mb-1.5 px-1">
        <Palette size={18} className="text-indigo-500" weight="fill" />
        <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Theme</span>
      </div>
      <div className="flex gap-1.5 flex-wrap">
        {THEMES.map(t => {
          const isActive = theme === t.key;
          return (
            <button
              key={t.key}
              onClick={(e) => { e.stopPropagation(); setTheme(t.key); }}
              data-testid={`theme-chip-${t.key}`}
              title={t.label}
              className="relative w-8 h-8 rounded-full border-2 flex items-center justify-center transition-transform hover:scale-110"
              style={{ background: t.swatch, borderColor: isActive ? t.ring : 'transparent' }}
            >
              {isActive && <Check size={14} weight="bold" className={t.key === 'light' ? 'text-gray-800' : 'text-white'} />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ThemeToggleMenuItem;
